import React, { useState, useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Header from './components/AdminComponent/Header';
import HeaderClinic from './components/ClinicComponent/Header';
import Clinica from './components/AdminComponent/Clinica';
import Terminos from './components/AdminComponent/terminosycondiciones';
import Login from './components/AdminComponent/Login';
import Calendar from './components/PatientComponent/CalendarView';
import CalendarDoctor from './components/DoctorComponent/CalendarView';
import PatientPerfil from './components/PatientComponent/PatientProfile';
import DoctorControl from './components/DoctorComponent/DoctorControl';
import HistoriaOffline from './components/DoctorComponent/HistoriaOffline';
import PatientControl from './components/PatientComponent/PatientControl';
import DoctorPerfil from './components/DoctorComponent/DoctorProfile';
import { FormProvider } from './components/AdminComponent/FormContext';
import DoctorAssignedDocuments from './components/DoctorComponent/DoctorAssignedDocuments';
import PatientAssignedDocuments from './components/PatientComponent/PatientAssignedDocuments';
import MarketPlace from './components/PatientComponent/MarketPlace';
import AgendarCita from './components/PatientComponent/AgendarCita';
import PagRespuestaAgendarCitaPayU from './components/PayU/PagRespuestaAgendarCitaPayU';
import { Registro } from './components/AdminComponent/Registro';
import PagRespuestaAfiliadoPayU from './components/PayU/PagRespuestaAfiliadoPayU';
import OAuthCallback from './components/AdminComponent/OAuthCallback';
import { DataUserProvider, useDataUser } from './context/dataUserContext';
import { MembershipProvider } from './context/MembershipContext';
import ErrorPage from './components/ErrorPage/ErrorPage';
import Cursos from './components/DoctorComponent/Cursos';
import Aliados from './components/DoctorComponent/Aliados';
import PatientAliados from './components/PatientComponent/PatientAliados';
import PagRespuestaCursoPayU from './components/PayU/PagRespuestaCursoPayU';
import NavbarPatientDoctor from './components/PatientComponent/NavbarPatientDoctor';
import Notificaciones from './components/PatientComponent/Notificaciones';
import Dashboard from './components/AdminComponent/Dashboard';
import DoctorAliadosBeneficios from './components/DoctorComponent/DoctorAliadosBeneficios';
import AgendarTeleconsulta from './components/DoctorComponent/AgendarTeleconsulta';
import ConfiguracionCitasDoctor from './components/DoctorComponent/ConfiguracionCitas';
import ConsentimientoInformado from './components/VideoCall/ConsentimientoInformado';
import ConsentimientoPublico from './components/ConsentimientoPublico';
import DebugPage from './components/DebugPage';
import PassToMember from './components/PatientComponent/PassToMember';
import PagRespuestaPassToMember from './components/PayU/PagRespuestaPassToMember';
import NavbarClinicAdmin from './components/ClinicComponent/NavbarClinicAdmin';
import ClinicProfile from './components/ClinicComponent/ClinicProfile';
import AdminComponent from './components/ClinicComponent/Admin';
import GraficoUsuarios from './components/ClinicComponent/Grafics';
import DoctorComponent from './components/ClinicComponent/Doctor';
import PatientComponent from './components/ClinicComponent/Patient';
import ClinicPatientDocumentsSearch from './components/ClinicComponent/ClinicPatientDocumentsSearch';
import RipsReport from './components/ClinicComponent/Report';
import CursosPagos from './components/ClinicComponent/CursosPagos';
import LoginVerificacion from './components/AdminComponent/LoginVerificacion';
import PagRespuestaAfiliadoEpayco from './components/ePayco/PagRespuestaAfiliadoEpayco';
import PagRespuestaAgendarCitaEpayco from './components/ePayco/PagRespuestaAgendarCitaEpayco';
import PagRespuestaCursoEpayco from './components/ePayco/PagRespuestaCursoEpayco';
import PagRespuestaUpgradeEpayco from './components/ePayco/PagRespuestaUpgradeEpayco';
import Facturacion from './components/AdminComponent/Facturacion';
import GestionPrecios from './components/ClinicComponent/GestionPrecios';
import GestionProfesiones from './components/ClinicComponent/GestionProfesiones';
import GestionMarketplace from './components/ClinicComponent/GestionMarketplace';
import RedplikaPlace from './components/Marketplace/RedplikaPlace';
import RedplikaPlaceDetalle from './components/Marketplace/RedplikaPlaceDetalle';
import MisProductosPlace from './components/DoctorComponent/MisProductosPlace';
import PagRespuestaMarketplaceEpayco from './components/ePayco/PagRespuestaMarketplaceEpayco';
import AliadosAdmin from './components/AdminComponent/AliadosAdmin';
import CitaTemporal from './components/CitaTemporal';
import VideoCallDroxy from './components/VideoCallDroxy';
import DroxyAgendar from './components/DroxyAgendar';
import MembershipTestPage from './components/Membership/MembershipTestPage';
import AutorizacionDatos from './components/AdminComponent/AutorizacionDatos';
import AutorizacionDatosM from './components/AdminComponent/AutorizacionDatosM';

const VideoCallAWS = lazy(() => import('./components/VideoCall/VideoCallAWS'));

const ProtectedRoute = ({ allowedRoles, requireRole = true, children }) => {
    const token = localStorage.getItem('token');
    const { role, setIsAuth } = useDataUser(); // Obtenemos el rol del contexto asi es mas dificil de manipular
    const isTokenValid = !!token; // Validar si el token existe

    // Obtener el rol del token directamente si el contexto no lo tiene actualizado
    let userRole = role;
    if (isTokenValid && (!userRole || userRole === '')) {
        try {
            const decoded = JSON.parse(atob(token.split('.')[1]));
            userRole = decoded.role || '';
            // Actualizar el contexto si encontramos un rol válido
            if (userRole) {
                setIsAuth(true);
            }
        } catch (error) {
            console.error('Error decodificando token:', error);
        }
    }

    // console.log('Token (isTokenValid):', isTokenValid);
    // console.log('User Role (contexto):', role);
    // console.log('User Role (token):', userRole);
    // console.log('requireRole:', requireRole);

    // Verificar autenticación y rol en tiempo real
    if (isTokenValid) {
        if (requireRole && userRole && !allowedRoles.includes(userRole)) {
            console.log('No autorizado para esta ruta. Rol:', userRole, 'Permitidos:', allowedRoles);
            return <Navigate to={`/${userRole}`} />;
        }
        // Si no hay rol pero el token es válido y no requiere rol específico, permitir acceso
        if (requireRole && !userRole) {
            console.log('Token válido pero sin rol. Esperando actualización del contexto...');
            // Dar un pequeño delay para que el contexto se actualice
            return <Navigate to="/" replace />;
        }
        return children;
    } else {
        console.log('No autenticado, redirigiendo...');
        setIsAuth(false); // Limpiamos contexto si el token es inválido
        localStorage.clear(); // Limpiamos el localStorage
        return <Navigate to="/" />;
    }
};

function App() {
    const [activeComponent, setActiveComponent] = useState('bienvenida');
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [patientName, setPatientName] = useState(localStorage.getItem('patientName'));
    const [doctorName, setDoctorName] = useState(localStorage.getItem('doctorName'));
    const [role, setRole] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('token');
        const role = localStorage.getItem('role');

        if (token && role) {
            setIsAuthenticated(true);
            setRole(role);
        } else {
            setIsAuthenticated(false); // Si el token o el rol no están, el usuario no está autenticado
        }
    }, []);

    const handleLogin = (username, role, patientName, doctorName) => {
        setIsAuthenticated(true);
        setRole(role);
        setPatientName(patientName);
        setDoctorName(doctorName);
    };

    return (
        <Router>
            <DataUserProvider>
                <MembershipProvider>
                    <FormProvider>
                        <Routes>
                        <Route path="*" element={<ErrorPage />} />
                        <Route path="/login" element={<Login callback={handleLogin} />} />
                        <Route path="/code-verification" element={<LoginVerificacion />} />
                        <Route path="/registro" element={<Registro />} />
                        <Route path="/registro-afiliado" element={<PagRespuestaAfiliadoPayU />} />
                        <Route path="/registro-afiliado-epayco" element={<PagRespuestaAfiliadoEpayco />} />
                        {/* Rutas públicas para registro directo */}
                        <Route path="/registro-gratuito" element={<Registro />} />
                        <Route path="/registro-pagado" element={<Registro />} />
                        {/* Rutas específicas para usuarios (pacientes) */}
                        <Route path="/registro-gratuito-usuario" element={<Registro />} />
                        <Route path="/registro-pagado-usuario" element={<Registro />} />
                        {/* Rutas de OAuth callback */}
                        <Route path="/oauth/google/callback" element={<OAuthCallback />} />
                        <Route path="/oauth/linkedin/callback" element={<OAuthCallback />} />
                        {/* Ruta para usuarios no autenticados */}
                        <Route path="/" element={<NavbarPatientDoctor />} >
                            <Route path="" element={< Navigate to="dashboard" />} />
                            <Route path="perfil" element={<Navigate to="/login" />} />
                            <Route path="dashboard" element={<Dashboard />} />
                            <Route path="teleconsultas" element={<AgendarTeleconsulta />} />
                            <Route path="directorio-profesionales" element={<MarketPlace />} />
                            <Route path="aliados" element={<Aliados />} />
                            <Route path="redplikaplace" element={<RedplikaPlace />} />
                            <Route path="redplikaplace/producto/:listingId" element={<RedplikaPlaceDetalle />} />
                        </Route>

                        {/* Ruta para administradores (solo accesible para el rol 'admin') */}
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute isAuthenticated={isAuthenticated} allowedRoles={['admin']}>
                                    <div className="min-h-screen bg-gray-100">
                                        <Header setActiveComponent={setActiveComponent} />
                                        <main className="p-4">
                                            {activeComponent === 'clinica' && <Clinica />}
                                        </main>
                                    </div>
                                </ProtectedRoute>
                            }
                        />

                        {/* Ruta para clínicas (solo accesible para el rol 'clinic') */}
                        <Route
                            path="/clinic"
                            element={
                                <ProtectedRoute isAuthenticated={isAuthenticated} allowedRoles={['clinic', 'clinicAdmin']}>
                                    <NavbarClinicAdmin />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="" element={< Navigate to="info-clinica" />} />
                            <Route path="info-clinica" element={<ClinicProfile />} />
                            <Route path="tablero-control" element={<GraficoUsuarios />} />
                            <Route path="administradores" element={<AdminComponent />} />
                            <Route path="afiliados" element={<DoctorComponent />} />
                            <Route path="usuarios" element={<PatientComponent />} />
                            <Route path="documentos-pacientes" element={<ClinicPatientDocumentsSearch />} />
                            <Route path="rips" element={<RipsReport />} />
                            <Route path="facturacion" element={<Facturacion />} />
                            <Route path="gestion-precios" element={<GestionPrecios />} />
                            <Route path="profesiones" element={<GestionProfesiones />} />
                            <Route path="marketplace" element={<GestionMarketplace />} />
                            <Route path="aliados" element={<AliadosAdmin />} />
                        </Route>

                        {/* Ruta para pacientes (solo accesible para el rol 'patient') */}
                        <Route
                            path="/patient"
                            element={
                                <ProtectedRoute isAuthenticated={isAuthenticated} allowedRoles={['patient']}>
                                    <NavbarPatientDoctor />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="" element={< Navigate to="dashboard" />} />
                            <Route
                                path="dashboard"
                                element={<Dashboard />}
                            />
                            <Route
                                path="perfil"
                                element={<PatientPerfil />}
                            />
                            <Route
                                path="calendario"
                                element={<Calendar />}
                            />
                            <Route
                                path="teleconsultas"
                                element={<PatientControl />}
                            />
                            <Route
                                path="notificaciones"
                                element={<Notificaciones />}
                            />
                            <Route
                                path="documentos-asignados"
                                element={<PatientAssignedDocuments />}
                            />
                            <Route
                                path="aliados"
                                element={<PatientAliados />}
                            />
                            <Route
                                path="directorio-profesionales"
                                element={<MarketPlace />}
                            />
                            <Route
                                path="redplikaplace"
                                element={<RedplikaPlace />}
                            />
                            <Route
                                path="redplikaplace/producto/:listingId"
                                element={<RedplikaPlaceDetalle />}
                            />
                            <Route
                                path="agendar-cita"
                                element={<AgendarCita />}
                            />

                            <Route
                                path="/patient/aprobacion-cita"
                                element={<PagRespuestaAgendarCitaPayU />}
                            />
                            <Route
                                path="aprobacion-cita-epayco"
                                element={<PagRespuestaAgendarCitaEpayco />}
                            />
                            <Route
                                path="miembro"
                                element={<PassToMember />}
                            />
                            <Route
                                path="miembro/:service/registro"
                                element={<PagRespuestaPassToMember />}
                            />
                        </Route>
                        {/* FIN RUTAS PACIENTE */}

                        {/* INICIO RUTAS DOCTOR */}
                        <Route
                            path="/doctor"
                            element={
                                <ProtectedRoute isAuthenticated={isAuthenticated} allowedRoles={['doctor']}>
                                    <NavbarPatientDoctor />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="" element={<Navigate to="dashboard" />} />
                            <Route
                                path="dashboard"
                                element={<Dashboard />}
                            />
                            <Route
                                path="perfil"
                                element={<DoctorPerfil />}
                            />
                            <Route
                                path="notificaciones"
                                element={<Notificaciones />}
                            />
                            <Route
                                path="calendario"
                                element={<CalendarDoctor />}
                            />
                            <Route
                                path="teleconsultas"
                                element={<DoctorControl />}
                            />
                            <Route
                                path="documentos-asignados"
                                element={<DoctorAssignedDocuments />}
                            />
                            <Route
                                path="configuracion-citas"
                                element={<ConfiguracionCitasDoctor />}
                            />
                            <Route
                                path="directorio-profesionales"
                                element={<MarketPlace />}
                            />
                            <Route
                                path="redplikaplace"
                                element={<RedplikaPlace />}
                            />
                            <Route
                                path="redplikaplace/producto/:listingId"
                                element={<RedplikaPlaceDetalle />}
                            />
                            <Route
                                path="mis-productos"
                                element={<MisProductosPlace />}
                            />
                            <Route
                                path="aliados"
                                element={<DoctorAliadosBeneficios />}
                            />
                            <Route
                                path="aliados/:nombreAfiliado"
                                element={<Cursos />}
                            />
                            <Route
                                path="pago-curso/:cursoId"
                                element={<PagRespuestaCursoPayU />}
                            />
                            <Route
                                path="historia-offline"
                                element={<HistoriaOffline />}
                            />
                            <Route
                                path="agendar-cita"
                                element={<AgendarCita />}
                            />
                            <Route
                                path='/doctor/aprobacion-cita'
                                element={<PagRespuestaAgendarCitaPayU />}
                            />
                        </Route>
                        {/* FIN RUTAS DOCTOR */}


                        {/* Ruta para consentimiento */}
                        <Route
                            path="/consentimiento"
                            element={<ConsentimientoInformado />}
                        />

                        {/* Ruta para consentimiento con appointmentId */}
                        <Route
                            path="/consentimiento/:appointmentId"
                            element={<ConsentimientoInformado />}
                        />

                        {/* Ruta para consentimiento externo - COMPLETAMENTE PÚBLICA */}
                        <Route
                            path="/consentimiento-externo"
                            element={<ConsentimientoPublico />}
                        />

                        {/* Ruta para consentimiento externo con appointmentId - COMPLETAMENTE PÚBLICA */}
                        <Route
                            path="/consentimiento-externo/:appointmentId"
                            element={<ConsentimientoPublico />}
                        />

                        {/* Ruta para videollamada - Ahora usa AWS por defecto */}
                        <Route
                            path="/video-call/:appointmentId"
                            element={
                                <ProtectedRoute isAuthenticated={isAuthenticated} requireRole={true} allowedRoles={['patient', 'doctor']}>
                                    <Suspense fallback={
                                        <div className="flex items-center justify-center min-h-screen bg-gray-900 text-white">
                                            <p className="text-lg">Cargando videoconsulta...</p>
                                        </div>
                                    }>
                                        <VideoCallAWS />
                                    </Suspense>
                                </ProtectedRoute>
                            }
                        />
                        
                        {/* Ruta para autorización de datos personales */}
                        <Route path="/autorizaciondatos" element={<AutorizacionDatos />} />
                        <Route path="/autorizaciondatosm" element={<AutorizacionDatosM />} />

                        {/* Ruta para términos y condiciones */}
                        <Route path="/terminos-y-condiciones" element={<Terminos />} />

                        <Route path="/resultado-cita-epayco" element={<PagRespuestaAgendarCitaEpayco />} />
                        <Route path="/resultado-curso-epayco" element={<PagRespuestaCursoEpayco />} />
                        <Route path="/resultado-marketplace-epayco" element={<PagRespuestaMarketplaceEpayco />} />
                        <Route path="/resultado-upgrade-epayco" element={<PagRespuestaUpgradeEpayco />} />

                        {/* Ruta para URLs temporales de citas */}
                        <Route path="/cita-temporal/:token" element={<CitaTemporal />} />

                        {/* Ruta para videoconsulta de Droxy */}
                        <Route path="/video-call-droxy/:appointmentId" element={<VideoCallDroxy />} />

                        <Route path="/facturacion" element={<Facturacion />} />

                        {/* Ruta pública para horarios y citas Droxy */}
                        <Route path="/salutio/droxy/agendar" element={<DroxyAgendar />} />

                        {/* Ruta para página de prueba del sistema de membresía */}
                        <Route path="/membership-test" element={<MembershipTestPage />} />
                    </Routes>
                </FormProvider>
                </MembershipProvider>
            </DataUserProvider>
        </Router>
    );
}

export default App;
